import React from 'react'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import { createResource, useResource } from '@/lib/i18n'

const GooglePlay = dynamic(import('@/components/common/google-play-btn'))
const Footer = dynamic(import('@/components/home/footer'))
const KPHead = dynamic(import('@/components/head'))
const TopNavigation = dynamic(import('@/components/top-navigation'))
const SendMessage = dynamic(import('@/components/home/send-message'))
const ProductBanner = dynamic(import('@/components/product/banner'))
const EasyProces = dynamic(import('@/components/product/esay-proces'))
const IncreaseProces = dynamic(import('@/components/product/increase-proces'))
const Benefit = dynamic(import('@/components/product/benefit'))

const resource = createResource({
  en: {
    description:
      'Kredit Pintar is fast liquid online loans, only need 5 minutes and ID card. Kredit Pintar is a trusted money loan place that is licensed and supervised by the OJK.',
  },
  id: {
    description:
      'Kredit Pintar adalah pinjaman online cepat cair, hanya butuh waktu 5 menit dan KTP. Kredit Pintar juga tempat pinjaman uang terpercaya yang berizin dan diawasi oleh OJK.',
  },
})

const PointarShop = () => {
  const { t } = useResource(resource)
  return (
    <>
      <KPHead metaTitle="pintarShop" />
      <Head>
        <meta name="description" content={t('description')} />
      </Head>
      <TopNavigation />
      <ProductBanner />
      <EasyProces />
      <IncreaseProces />
      <Benefit />
      <SendMessage />
      <Footer />
      <GooglePlay />
    </>
  )
}

export default PointarShop
